import axios from 'axios';
import Vue from 'vue';

const state = {
    active: null
};

const mutations = {
    load(state, chapter){
        state.active = chapter;
    }
};

const actions = {
    load({commit, state}, {product_id, chapter_id}){
        return axios.get(`/products/${product_id}/chapters/${chapter_id}`).then(response => commit('load', response.$data));
    },
    simulation({commit}, event){}
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
